<template>
  <div id="MeterreadingSolution" ref="initDemo">
    <NavBar v-if="appType" />
    <!-- <NavContents :appbackimage-url="appbackimageUrl" :app-type="appType" :app-nav-contents-data="appNavContentsData" :nav-contents-data="NavContentsData" :navsdata="navsdata" :backimage-url="backimageUrl" /> -->
    <NavContents
      :sortollindex="sortollindex"
      :dom-height-list="domHeightList"
      :appbackimage-url="appbackimageUrl"
      :app-type="appType"
      :app-nav-contents-data="appNavContentsData"
      :nav-contents-data="navContentsData"
      :navsdata="navsdata"
      :backimage-url="backimageUrl"
      @sortllTo="sortllTo"
    />
    <ProductProfile v-if="!appType" :app-product-profile-data="navContentsData" />

    <ProgrammeSummary
      :isanimated="isanimated[0]"
      :app-type="appType"
      :app-programme-summary-data="programmeSummaryData"
      :programme-summary-data="programmeSummaryData"
    />

    <PlanAdvantage
      :isanimated="isanimated[1]"
      :app-type="appType"
      :app-product-advantage-data="productAdvantagesData"
      :product-advantages-data="productAdvantagesData"
    />
    <ApplicationScenariost
      :isanimated="isanimated[2]"
      :app-type="appType"
      :app-useprocess-data="applicationScenariosData"
      :application-scenarios-data="applicationScenariosData"
    />
    <SuccessLists
      :isanimated="isanimated[3]"
      :app-success-lists-data="successListsData"
      :app-type="appType"
      :success-lists-data="successListsData"
    />
    <!-- <ServiceRecommendation
      :isanimated="isanimated[4]"
      :app-title="appTitle"
      :app-service-recommendation-data="appServiceRecommendationData"
      :app-type="appType"
      :service-recommendation-data="serviceRecommendationData"
    /> -->
  </div>
</template>
<script>

import mixin from '@/utils/mixin' // 引入mixin文件
// import card from '@/components/card/card'

// 移动端
// 产品简介
import ProductProfile from '@/components/productProfile/ProductProfile'
// 智能抄表方案优势
import PlanAdvantage from '@/components/planAdvantage/PlanAdvantage'
// 智能抄表成功案例
import SuccessLists from '@/components/successLists/SuccessLists'
// 公共导航背景图
import NavContents from '@/components/navContents/NavContents'
// 智能相关服务与推荐
// import ServiceRecommendation from '@/components/serviceRecommendation/ServiceRecommendation'
// //公共应用场景（图片）
import ApplicationScenariost from '@/components/applicationScenariost/ApplicationScenariost'
// 智能抄表方案概述
import ProgrammeSummary from '@/components/programmeSummary/ProgrammeSummary'
// const animatedHeight = 300
export default {
  name: 'MeterreadingSolution',
  components: {
    NavContents,
    PlanAdvantage,
    SuccessLists,
    // ServiceRecommendation,
    ApplicationScenariost,
    ProgrammeSummary,
    // 移动端组件
    ProductProfile
  },
  mixins: [mixin],
  props: {
    appType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // 二级导航
      // 导航背景
      backimageUrl:
        'https://iotai.oss-cn-beijing.aliyuncs.com/portal/MeterreadingSolution/glbg.jpg',
      // 移动端背景
      appbackimageUrl: 'https://iotai.oss-cn-beijing.aliyuncs.com/portal/appimg/wrjgljtznxjjjfa.jpg',
      // 导航内容
      navContentsData: [
        {
          name: '无人机公路交通智能巡检解决方案',
          content:
            '系统实现跨无人机平台数据接入，并基于Seer平台核心能力，定制针对公路交通巡检的智能管理平台，提升无人机在公路交通管理中的智能化、系统化、标准化应用。',
          buttoncontenturl: '',
          buttoncontent: '立即使用',
          flag: false,
          path: 'serviceConsultation',
          buttonkaifa: '服务咨询'
        }
      ],
      // 方案概述
      programmeSummaryData: {
        name: '- 方案概述 -',
        content:
          '根据无人机在公路交通管理的各应用场景需求，按云平台架构设计，并对接交通管理部门现有的视频监控管理系统。系统主要包含感知设备、数据链、飞行平台、服务支撑层和应用层，其中应用层包括任务系统、飞行作业系统、人员与设备管理系统、维护系统等，最终形成标准化底层+多场景应用层的智能无人机管理平台方案。基于Seer AI的图像识别和深度学习能力，定制针对公路交通巡检的智能管理平台。',
        image: 'https://iotai.oss-cn-beijing.aliyuncs.com/portal/jjfa/wrjgl.jpg'
      },
      // 方案优势
      productAdvantagesData: [
        {
          image:
            'https://iotai.oss-cn-beijing.aliyuncs.com/portal/MeterreadingSolution/6.jpg',
          name: '智能化程度高',
          content:
            '系统具备丰富的AI模型库，可适应公路交通巡检的多种智能识别场景。'
        },
        {
          image:
            'https://iotai.oss-cn-beijing.aliyuncs.com/portal/MeterreadingSolution/13.jpg',
          name: '跨平台兼容',
          content:
            '可对接用户现有各种监控平台，且可向其他第三方系统提供流媒体服务，共享无人机巡检视频。'
        },
        {
          image:
            'https://iotai.oss-cn-beijing.aliyuncs.com/portal/MeterreadingSolution/4.jpg',
          name: '可扩展性强',
          content:
            '支持接入第三方算法库，根据用户需求适用于更多智能化应用场景。'
        },
        {
          image:
            'https://iotai.oss-cn-beijing.aliyuncs.com/portal/MeterreadingSolution/7.jpg',
          name: '丰富巡检手段',
          content:
            '提供空中立体巡检和机动巡检手段，配合其他系统，提升用户公路智能化管理水平。'
        }
      ],
      // 应用场景
      applicationScenariosData: [
        {
          image:
            'https://iotai.oss-cn-beijing.aliyuncs.com/portal/MeterreadingSolution/glyy01.jpg',
          name: '违章取证',
          content:
            '通过无人机回传实时视频，快速进行车牌识别、违章占道识别、事故勘察，有效提高了工作效率。'
        },
        {
          image:
            'https://iotai.oss-cn-beijing.aliyuncs.com/portal/MeterreadingSolution/glyy02.jpg',
          name: '路政资产',
          content:
            '通过无人机回传实时视频，快速进行路产设施识别、桥梁检测、正射影响拼接，高效便捷。'
        },
        {
          image:
            'https://iotai.oss-cn-beijing.aliyuncs.com/portal/MeterreadingSolution/glyy03.jpg',
          name: '工程建设',
          content:
            '通过无人机回传实时视频，快速进行勘察测绘、施工验收，有效的提高了工作效率，并且极大地减少了成本开支。'
        },
        {
          image:
            'https://iotai.oss-cn-beijing.aliyuncs.com/portal/MeterreadingSolution/glyy04.jpg',
          name: '应急支援',
          content:
            '通过在无人机上装载照明工具、喊话器等载荷进行照明喊话，回传实时视频到平台进行拥堵数据分析统计。'
        },
        {
          image:
            'https://iotai.oss-cn-beijing.aliyuncs.com/portal/MeterreadingSolution/glyy05.jpg',
          name: '风险监控',
          content:
            '通过无人机进行路面异物识别、坑洼裂缝识别、占道施工识别，快速排查各种安全隐患，大大提高了公路安全系数。'
        }
      ],
      // 成功案列
      successListsData: [
        {
          image:
            'https://iotai.oss-cn-beijing.aliyuncs.com/portal/MeterreadingSolution/glcg.jpg',
          name: '西安某公路智能巡检系统项目',
          content:
            '无人机公路交通智能巡检系统基于自研AI能力构建大数据分析系统，根据无人机系统提供的高清可见光照片、红外成像、实时视频、DOM等，自动快速完成图像拼接及识别、自动取证、报警提示、报表生成等主要巡检工作项，大幅提升无人机巡检的智能化和实用化。'
        }
      ],
      // 相关服务推荐
      serviceRecommendationData: [
        {
          flag: true,
          path: 'https://iot.e-byte.com/ai/#/meterRecognition',
          name: '电表识别',
          content: '点击查看更多详情'
        },
        {
          flag: true,
          path: 'https://iot.e-byte.com/ai/#/gasRecognition',
          name: '气表识别',
          content: '点击查看更多详情'
        }
      ],
      // 移动端
      // 导航内容
      appNavContentsData: {
        name: '无人机公路交通智能巡检解决方案',
        button: '服务咨询',
        path: 'serviceConsultation'
      },
      // 相关服务推荐
      appTitle: '- 相关服务推荐 -',
      appServiceRecommendationData: [
        {
          path: 'https://iot.e-byte.com/ai/#/meterRecognition',
          img: 'https://iotai.oss-cn-beijing.aliyuncs.com/aiPortal/appimg/fwdianb.jpg',
          name: '电表识别',
          content:
            '气表识别服务，基于深度学习技术，准确识别气表用电量读数，提供各种型号机械表、数字表的读数识别能力，帮助客户准确识别气表读数。'
        },
        {
          img: 'https://iotai.oss-cn-beijing.aliyuncs.com/aiPortal/appimg/fwqb.jpg',
          name: '气表识别',
          path: 'https://iot.e-byte.com/ai/#/gasRecognition',
          content:
            '气表识别服务，基于深度学习技术，准确识别气表用电量读数，提供各种型号机械表、数字表的读数识别能力，帮助客户准确识别气表读数。'
        }
      ]
    }
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
  }
}
</script>

<style scoped>
.useProcess {
  width: 100%;
  height: 451px;
  background: #f2f2f2;
}
.productArchitecture {
  width: 100%;
  height: 451px;
}
</style>

